<template>
    <ul class="g_faqAccordion" role="accordion">
        <faq-accordion-collapse
            v-for="(feature, index) in items"
            :feature="feature"
            :key="index"
        >
            <span class="g_visually_hidden">Accordion item {{index}} of {{items.length}}</span>
        </faq-accordion-collapse>
    </ul>
</template>

<script>
import FaqAccordionCollapse from './FaqAccordionCollapse'

export default {
    name: 'FaqAccordion',
    props: {
        items: {
            type: Array,
            required: true
        }
    },
    components: {
        FaqAccordionCollapse
    }
}
</script>

<style lang="sass" rel="stylesheet/sass">
@import ~nespresso-bi/utilities
@import ~nespresso-bi/brand/variables

.g_faqAccordion
    margin-bottom: ($gap * 2)
    padding: 0
    list-style: none

+mobile
    .g_faqAccordion
        max-width: calc(100vw - 2.5em)
</style>
